import Routes from "routing/Routes";
export const EVENT_DEFINITIONS_TITLE = "Event Definitions";
export const ALERTS_TITLE = "Alerts & Events";
export const NOTIFICATIONS_TITLE = "Notifications";
export const PAGE_NAVIGATION_TITLE = "Alerts";
const eventsBindings = {
  pageNavigation: [
    {
      description: PAGE_NAVIGATION_TITLE,
      children: [
        { description: ALERTS_TITLE, path: Routes.ALERTS.LIST, exactPathMatch: true },
        { description: EVENT_DEFINITIONS_TITLE, path: Routes.ALERTS.DEFINITIONS.LIST },
        { description: NOTIFICATIONS_TITLE, path: Routes.ALERTS.NOTIFICATIONS.LIST }
      ]
    }
  ]
};
export default eventsBindings;
